import { isLkmDomain } from '../router/utils/hostUtils'

export const apiPath = isLkmDomain()
  ? process.env.REACT_APP_LKM_API_PATH
  : process.env.REACT_APP_API_PATH

export const apiPathLkp = process.env.REACT_APP_API_PATH
